// extracted by mini-css-extract-plugin
export default {"wrapper":"BaseLayout_wrapper__VmP9b","absoluteBackgroundNoArtists":"BaseLayout_absoluteBackgroundNoArtists__-2kIW"};